<template>
  <div class="h-full flex flex-col bg-[#f8fafc] gap-4 p-2 overflow-y-auto custom-scrollbar">
    <!-- Miscellaneous Registration Form -->
    <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden border-t-4 border-t-[#0d4169] flex flex-col">
      <div class="px-6 pt-5 pb-1 shrink-0">
        <h2 class="text-base font-bold text-[#0d4169] text-left">Miscellaneous Registration</h2>
      </div>

      <form class="px-6 pb-5 pt-2 shrink-0" @submit.prevent="handleSubmit">
        <div class="flex flex-wrap gap-x-10 gap-y-3">

          <!-- Tax Type -->
          <div class="flex flex-col gap-1 w-[200px]">
            <label class="text-[0.7rem] font-bold text-slate-600 text-left">Tax Type</label>
            <select v-model="form.taxType" class="w-full px-2 py-1.5 border border-[#cbd5e1] rounded outline-none focus:border-[#0d4169] text-xs bg-white cursor-pointer h-[34px]">
              <option value="" disabled selected>Select Tax Type</option>
              <option value="VAT">VAT</option>
              <option value="Service Charge">Service Charge</option>
              <option value="Income Tax">Income Tax</option>
              <option value="Withholding Tax">Withholding Tax</option>
            </select>
          </div>

          <!-- Tax Value -->
          <div class="flex flex-col gap-1 w-[160px]">
            <label class="text-[0.7rem] font-bold text-slate-600 text-left">Tax Value (%)</label>
            <div class="relative flex items-center h-[34px]">
              <input
                v-model.number="form.taxValue"
                type="number"
                min="0"
                step="0.01"
                class="w-full pl-2 pr-7 py-1.5 border border-[#cbd5e1] rounded outline-none focus:border-[#0d4169] text-xs h-[34px]"
                placeholder="0.00"
              >
              <span class="absolute right-2 text-slate-400 text-xs font-bold">%</span>
            </div>
          </div>

          <!-- Contingency -->
          <div class="flex flex-col gap-1 w-[200px]">
            <label class="text-[0.7rem] font-bold text-slate-600 text-left">Contingency Type</label>
            <select v-model="form.contingencyType" class="w-full px-2 py-1.5 border border-[#cbd5e1] rounded outline-none focus:border-[#0d4169] text-xs bg-white cursor-pointer h-[34px]">
              <option value="" disabled selected>Select Type</option>
              <option value="Food">Food</option>
              <option value="Beverage">Beverage</option>
              <option value="General">General</option>
            </select>
          </div>

          <!-- Contingency Value -->
          <div class="flex flex-col gap-1 w-[160px]">
            <label class="text-[0.7rem] font-bold text-slate-600 text-left">Contingency (%)</label>
            <div class="relative flex items-center h-[34px]">
              <input
                v-model.number="form.contingencyValue"
                type="number"
                min="0"
                step="0.01"
                class="w-full pl-2 pr-7 py-1.5 border border-[#cbd5e1] rounded outline-none focus:border-[#0d4169] text-xs h-[34px]"
                placeholder="0.00"
              >
              <span class="absolute right-2 text-slate-400 text-xs font-bold">%</span>
            </div>
          </div>

          <!-- Additional S.C -->
          <div class="flex flex-col gap-1 w-[200px]">
            <label class="text-[0.7rem] font-bold text-slate-600 text-left">Additional S.C Type</label>
            <select v-model="form.additionalType" class="w-full px-2 py-1.5 border border-[#cbd5e1] rounded outline-none focus:border-[#0d4169] text-xs bg-white cursor-pointer h-[34px]">
              <option value="" disabled selected>Select Type</option>
              <option value="Service Charge">Service Charge</option>
              <option value="Surcharge">Surcharge</option>
              <option value="Cover Charge">Cover Charge</option>
            </select>
          </div>

          <!-- Additional Value -->
          <div class="flex flex-col gap-1 w-[160px]">
            <label class="text-[0.7rem] font-bold text-slate-600 text-left">Additional S.C (%)</label>
            <div class="relative flex items-center h-[34px]">
              <input
                v-model.number="form.additionalValue"
                type="number"
                min="0"
                step="0.01"
                class="w-full pl-2 pr-7 py-1.5 border border-[#cbd5e1] rounded outline-none focus:border-[#0d4169] text-xs h-[34px]"
                placeholder="0.00"
              >
              <span class="absolute right-2 text-slate-400 text-xs font-bold">%</span>
            </div>
          </div>

          <!-- Remark -->
          <div class="flex flex-col gap-1 w-[200px]">
            <label class="text-[0.7rem] font-bold text-slate-600 text-left">Remark</label>
            <input
              v-model="form.remark"
              type="text"
              class="w-full px-2 py-1.5 border border-[#cbd5e1] rounded outline-none focus:border-[#0d4169] text-xs h-[34px]"
              placeholder="Optional note"
            >
          </div>

          <!-- Action Button -->
          <div class="flex items-end pb-[1px]">
            <button type="submit" class="px-10 py-1.5 bg-[#0d4169] text-white text-[0.7rem] font-bold rounded shadow-sm hover:bg-[#0a3354] transition-all h-[34px]">
              {{ editingIndex !== null ? 'UPDATE' : 'ADD' }}
            </button>
          </div>
        </div>
      </form>

      <!-- Registered List Table -->
      <div class="px-4 pb-4 pt-2 overflow-x-auto">
        <table class="border-collapse bg-white w-full min-w-max">
          <thead>
            <tr>
              <th>No.</th>
              <th>Tax Type</th>
              <th>Tax (%)</th>
              <th>Contingency Type</th>
              <th>Contingency (%)</th>
              <th>Additional S.C Type</th>
              <th>Additional S.C (%)</th>
              <th>Remark</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="items.length === 0">
              <td colspan="9" class="text-center text-slate-400 py-6 text-xs">No records registered yet.</td>
            </tr>
            <tr v-for="(row, index) in items" :key="index" class="hover:bg-slate-50 border-b border-slate-100">
              <td class="text-center text-xs text-slate-500">{{ index + 1 }}</td>
              <td class="font-semibold text-[#0d4169]">{{ row.taxType }}</td>
              <td class="text-center font-bold text-green-700">{{ row.taxValue }}%</td>
              <td>{{ row.contingencyType }}</td>
              <td class="text-center font-bold text-blue-700">{{ row.contingencyValue }}%</td>
              <td>{{ row.additionalType }}</td>
              <td class="text-center font-bold text-purple-700">{{ row.additionalValue }}%</td>
              <td class="text-slate-500 text-xs">{{ row.remark }}</td>
              <td class="text-center">
                <a @click="handleEdit(index)" class="text-blue-500 text-xs font-bold cursor-pointer hover:underline px-1">Edit</a>
                <!-- <a @click="handleDelete(index)" class="text-red-500 text-xs font-bold cursor-pointer hover:underline px-1">Delete</a> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const items = ref([
  { taxType: 'VAT', taxValue: 15, contingencyType: 'Food', contingencyValue: 10, additionalType: 'Service Charge', additionalValue: 5, remark: 'Standard rates' },
  { taxType: 'Service Charge', taxValue: 10, contingencyType: 'Beverage', contingencyValue: 8, additionalType: 'Surcharge', additionalValue: 3, remark: 'Bar rates' },
])

const emptyForm = () => ({
  taxType: '',
  taxValue: '',
  contingencyType: '',
  contingencyValue: '',
  additionalType: '',
  additionalValue: '',
  remark: ''
})

const form = ref(emptyForm())
const editingIndex = ref(null)

const handleSubmit = () => {
  if (!form.value.taxType) return
  const entry = { ...form.value }
  if (editingIndex.value !== null) {
    items.value[editingIndex.value] = entry
    editingIndex.value = null
  } else {
    items.value.unshift(entry)
  }
  form.value = emptyForm()
}

const handleEdit = (index) => {
  form.value = { ...items.value[index] }
  editingIndex.value = index
}

// const handleDelete = (index) => {
//   if (confirm('Delete this record?')) {
//     items.value.splice(index, 1)
//     if (editingIndex.value === index) {
//       editingIndex.value = null
//       form.value = emptyForm()
//     }
//   }
// }
</script>

<style scoped>
table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.75rem;
  color: #1e293b;
  border-collapse: collapse;
}

th, td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

th {
  background: #f1f5f9;
  cursor: default;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 20;
}

.custom-scrollbar::-webkit-scrollbar { width: 8px; height: 8px; }
.custom-scrollbar::-webkit-scrollbar-track { background: #f1f5f9; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
</style>
